/*
 * SHARED POPUP STYLES
 *
 * Keeps dialog chrome and field hierarchy consistent across feature popups.
 *
 * Recent changes:
 * - Extracted the compact task-popup shell styles for reuse by note dialogs.
 */

import { THEME_CLASSES } from '../../constants/themeConstants';

export const POPUP_PANEL_CLASS_NAME = '!w-[calc(100vw-1.5rem)] !max-w-5xl !rounded-2xl sm:!w-[calc(100vw-3rem)]';
export const POPUP_HEADER_CLASS_NAME = '!px-4 !py-1.5';
export const POPUP_TITLE_CLASS_NAME = '!m-0 !text-lg !leading-7';
export const POPUP_CLOSE_CLASS_NAME = '!h-7 !w-7 !text-base';
export const POPUP_LABEL_CLASS_NAME = `mb-2 block text-xs font-semibold uppercase tracking-[0.12em] ${THEME_CLASSES.text.secondary}`;
